import React from "react";
import { PremiumInfoTrialWidgetTemplate } from "themes/application/payment/components";

function PremiumInfoTrialWidget(props) {
    return <PremiumInfoTrialWidgetTemplate {...props} />;
}

export default PremiumInfoTrialWidget;
